module.exports = __webpack_public_path__ + "img/img-2.4be60944.jpg";